<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App',
  data () {
    return {
    }
  },
  mounted () {
  }
}
</script>

<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #000;
  margin: 0;
  padding: 0;
  width: 100%;
  height: 100%;
}
html, body {
  width: 100%;
  height: 100%;
}
* {
  margin:0;
  padding:0;
  box-sizing: border-box;
}
</style>



// WEBPACK FOOTER //
// src/App.vue